/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  Row,
  Col,
  Panel,
  Button,
} from 'react-bootstrap';
import {
  injectIntl,
} from 'react-intl';
import CSSModules from 'react-css-modules';
import LineChart from 'loracoms/LineChart';
import { getBills } from 'loraapi/Billing';
import PayStrategy from '../PayStrategy';
import styles from './styles/main.scss';
import imgUser from './images/user.svg';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  orgBasic: React.PropTypes.object.isRequired,
  accountBasic: React.PropTypes.object.isRequired,
  plan: React.PropTypes.object.isRequired,
};

class CommercialView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      orgBasic: props.orgBasic,
      accountBasic: props.accountBasic,
      plan: props.plan,
      series: {
        categories: [],
        costs: {
          name: this.intlMsg('chart.series.costs'),
          data: [],
          yAxisIndex: 0,
        },
        nodes: {
          name: this.intlMsg('chart.series.nodes'),
          data: [],
          yAxisIndex: 1,
        },
      },
    };
  }

  componentDidMount() {
    this.loadBills();
  }

  componentWillReceiveProps(nextProps) {
    const { orgBasic, accountBasic, plan } = nextProps;
    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic });
    }
    if (accountBasic !== this.props.accountBasic) {
      this.setState({ accountBasic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  loadBills() {
    const to = moment().add(1, 'months').format('YYYYMM01');
    const from = moment().subtract(11, 'months').format('YYYYMM01');
    getBills(from, to).then((resp) => {
      // list last 12 months bills, if absent, pad with zero
      let t = moment().subtract(11, 'months');
      const eom = moment().format('YYYYMM');
      const periods = [];
      while (t.format('YYYYMM') <= eom) {
        periods.push(t.format('YYYYMM'));
        t = t.add(1, 'months');
      }
      const bills = _.sortBy(resp.body.list, 'period');
      const charges = periods.map((p) => {
        const bill = _.find(bills, b => b.period === p);
        if (_.isNil(bill)) {
          return 0;
        }
        return _.round(bill.charge, 2);
      });
      const vols = periods.map((p) => {
        const bill = _.find(bills, b => b.period === p);
        if (_.isNil(bill)) {
          return 0;
        }
        return bill.vol;
      });
      this.setState({
        series: {
          categories: periods,
          costs: {
            name: this.intlMsg('chart.series.costs'),
            data: charges,
            yAxisIndex: 0,
          },
          nodes: {
            name: this.intlMsg('chart.series.nodes'),
            data: vols,
            yAxisIndex: 1,
          },
        },
      });
    });
  }

  intlMsg(id) {
    return this.props.intl.formatMessage({
      id: `billing.commercialview.${id}`,
      defaultMessage: `billing.commercialview.${id}`,
    });
  }

  billday(d) {
    if (this.props.intl.locale === 'zh') {
      return d;
    }
    switch (d) {
      case 1:
        return '1st';
      case 2:
        return '2nd';
      case 3:
        return '3rd';
      default:
        return `${d}th`;
    }
  }

  renderInfoPanel() {
    const { orgBasic, plan } = this.state;
    return (
      <Panel bsStyle="aisz-white">
        <Row>
          <Col md={4}>
            <div styleName="bills-info">
              <div styleName="content-card">
                <h5 styleName="bold-title">
                  { this.intlMsg('bills.lbl') }
                </h5>
                <span styleName="billday">
                  <span>{ this.intlMsg('bills.billday.desc.prefix') }</span>
                  {' '}
                  <span styleName="billday-val">{this.billday(plan.billday)}</span>
                  {' '}
                  <span>{ this.intlMsg('bills.billday.desc.postfix') }</span>
                </span>
                {' '}
                <div styleName="bill-help">
                  { this.intlMsg('bills.billhelp.desc1') }
                </div>
                <Button
                  bsStyle="aisz-primary-b"
                  onClick={() => this.props.pushState('/billing/billlogs')}
                >
                  { this.intlMsg('bills.billlog.btn')}
                  {' '}
                  <i className="fa fa-file-text-o" />
                </Button>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <h5 styleName="bold-title extra-pd">{this.intlMsg('paystrategy')}</h5>
            <div styleName="extra-pd">
              <PayStrategy />
            </div>
          </Col>
          <Col md={4}>
            <div styleName="basic-info">
              <div styleName="content-card">
                <h5 styleName="bold-title">
                  {this.intlMsg('balance.lbl')}
                </h5>
                <div styleName="balance">
                  <span styleName="balance-val">
                    {orgBasic.balance}
                  </span>
                  {' '}
                  <span> {this.intlMsg('balance.unit')} </span>
                </div>
                <div>
                  <ul className="list-inline">
                    <li>
                      <Button
                        bsStyle="aisz-primary"
                        onClick={() => this.props.pushState('/billing/recharge')}
                      >
                        {this.intlMsg('recharge.btn')}
                      </Button>
                    </li>
                    <li>
                      <Button
                        bsStyle="aisz-link"
                        onClick={() => this.props.pushState('/billing/balogs')}
                      >
                        {this.intlMsg('balance.logs.link')}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Panel>
    );
  }

  renderChartPanel() {
    return (
      <Panel bsStyle="aisz-white">
        <LineChart
          height={360}
          yAxis={[
            {
              name: this.intlMsg('chart.yaxis.costs'),
            },
            {
              name: this.intlMsg('chart.yaxis.nodes'),
              splitLine: {
                show: false,
              },
            },
          ]}
          legend={{
            data: [
              this.intlMsg('chart.series.costs'),
              this.intlMsg('chart.series.nodes'),
            ],
          }}
          series={[
            this.state.series.costs,
            this.state.series.nodes,
          ]}
          categories={this.state.series.categories}
        />
      </Panel>
    );
  }

  render() {
    return (
      <div>
        {this.renderInfoPanel()}
        {this.renderChartPanel()}
      </div>
    );
  }
}

CommercialView.propTypes = propTypes;


const mapStateToProps = state => ({
  orgBasic: state.org.basic.data || {},
  accountBasic: state.account.basic.data || {},
  plan: state.billing.plan.data || {},
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(CommercialView, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Billing/coms/CommercialView/index.jsx